import { H1, P } from '@berlitz/globals'
import Help from '@berlitz/streamline-icons/lib/regular/01-Interface-Essential/14-Alerts/QuestionCircle'
import Email from '@berlitz/streamline-icons/lib/regular/19-Emails/07-Email-Actions/EmailActionUnread'
import AtRiskNotificationCard from '@components/AtRiskNotificationCard'
import IconWrapper from '@components/IconWrapper'
import PageTitle from '@components/PageTitle'
import Radio from '@components/Radio'
import RouteLink from '@components/RouteLink'
import { mainNav, subtitle, title } from '@utils/stubdata/support.json'
import React from 'react'
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl'
import PortalStudentProfile from '../../../classes/StudentProfile'
import { connect } from 'react-redux'
import { StoreProps } from '@interfaces/StoreState'
import { Col, Row } from 'react-styled-flexboxgrid'
import { IconType, LayoutProps, MainNavProps } from './interface'
import { LabelWrapper, StyledRadio } from './style'
import { CONTACT_US } from '@utils/constants/cases'

const IconMapping: IconType = {
  Help: <Help />,
  Email: <Email />,
}

class Layout extends React.Component<LayoutProps & InjectedIntlProps> {
  render() {
    const { activeMainNav, children, userProfile } = this.props
    const pageTitle = (mainNav.find((nav) => nav.value === activeMainNav) || { label: '' }).label

    const is2bStudentOnly = !!(
      userProfile?.info?.StudentProfile?.StudentProfileInfo &&
      new PortalStudentProfile(userProfile.info.StudentProfile.StudentProfileInfo).is2bStudentOnly
    )
    return (
      <>
        <PageTitle title={pageTitle} />
        <div>
          <Row>
            <Col xs={12} md={12} lg={6}>
              <H1 disableMargin>
                <FormattedMessage id={title} defaultMessage={title} />
              </H1>
              <P size="sm">
                <FormattedMessage id={subtitle} defaultMessage={subtitle} />
              </P>
            </Col>
            <Col xs={12} md={12} lg={6}>
              <AtRiskNotificationCard />
            </Col>
          </Row>
          <StyledRadio value={activeMainNav} onChange={() => {}} name="mainNav" fullWidth>
            {mainNav
              .filter((nav) => !is2bStudentOnly || nav.value === CONTACT_US)
              .map(({ id, label, value, url, icon = 'Help' }: MainNavProps) => (
                <React.Fragment key={id}>
                  <Radio.Button value={value}>
                    <RouteLink key={url} path={url}>
                      <LabelWrapper>
                        <IconWrapper>{IconMapping[icon]}</IconWrapper>
                        <FormattedMessage id={label} />
                      </LabelWrapper>
                    </RouteLink>
                  </Radio.Button>
                </React.Fragment>
              ))}
          </StyledRadio>
          {children}
        </div>
      </>
    )
  }
}

function mapStateToProps(store: StoreProps) {
  return {
    userProfile: store.userProfile,
  }
}

export default injectIntl(connect(mapStateToProps)(Layout))
